export const downloadResumePdf = async (
  downloadUrl: string,
  fileBasename: string,
) => {
  const response = await fetch(downloadUrl, {
    method: "GET",
    credentials: "omit",
  });
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = `${fileBasename}.pdf`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
};
